import {
  Box,
  CircularProgress,
  circularProgressClasses,
  Typography,
} from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.SetupChecklist;

const RING_SIZE = 56;
const RING_THICKNESS = 4;

type Props = {
  value: number;
  total: number;
};

export const SetupProgressRing = ({ value, total }: Props) => {
  const { t } = useResource();
  const percentage = total === 0 ? 0 : (value / total) * 100;

  return (
    <Box
      position="relative"
      display="inline-flex"
      flexShrink={0}
      role="progressbar"
      aria-label={t(RESOURCES.StepsCompleted, { completed: value, total })}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={RING_SIZE}
        thickness={RING_THICKNESS}
        sx={{ color: "divider" }}
      />
      <CircularProgress
        variant="determinate"
        value={percentage}
        size={RING_SIZE}
        thickness={RING_THICKNESS}
        sx={{
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" fontWeight={600} color="primary">
          {`${value}/${total}`}
        </Typography>
      </Box>
    </Box>
  );
};
